"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOtherDisorders = createOtherDisorders;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const otherDisorders_1 = require("../../../forms/ktx/transplantation-screening/medical-history/otherDisorders");
const messages = {
    title: {
        id: "ktx.dashboard.other_disorders",
        defaultMessage: "Egyéb belgyógyászati betegségek"
    }
};
function createOtherDisorders(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.otherDisorders);
    const m = { ...otherDisorders_1.diseasesMessages, ...otherDisorders_1.hasDiseaseMessages };
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: formatMessageMap(m, event.value)
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
